import { Flex } from '@mantine/core';
import { PropsWithChildren, useContext, useEffect } from 'react';
import { useDashboardController } from '@dealstack/frontend/app/pages/Dashboard/useDashboardController.ts';
import { CapInvalidTransactionsWarning } from '@dealstack/frontend/shared/components/CapInvalidTransactionsWarning/CapInvalidTransactionsWarning.tsx';
import { DateSelectionMenu } from '@dealstack/frontend/app/pages/Project/Cap/common/DateSelectMenu/dateSelectMenu.tsx';
import { CapHeaderContext } from '@dealstack/frontend/app/pages/Project/Cap/common/CapPageHeader/useCapPageHeaderController.tsx';
import { DealContext } from '@dealstack/frontend/app/pages/Project/DealDashboard/DealContext';
import { PageHeader } from '@dealstack/frontend/shared/layout/PageHeader/PageHeader.tsx';

interface Props {
	title?: string;
	hideBreadcrumbs?: boolean;
}

export const CapPageHeader = ({ title, hideBreadcrumbs, children }: PropsWithChildren<Props>) => {
	const { filterDate, setFilterDate } = useContext(CapHeaderContext);
	const { isAllTransactionValidInDeal, navigateToEntityWithInvalidTransactions, dealId } =
		useContext(DealContext);
	const { setSelectedDealId } = useDashboardController();

	useEffect(() => {
		setSelectedDealId(dealId);
	}, [dealId]);

	return (
		<PageHeader pageTitle={title} hideBreadcrumbs={hideBreadcrumbs}>
			<Flex align="center" justify="space-between" gap="2rem" style={{ flex: 1 }}>
				<DateSelectionMenu
					dateTo={filterDate || null}
					maxDate={new Date()}
					setFilterDate={setFilterDate}
					allowDeselect={true}
					defaultDate={filterDate || undefined}
				/>
				<Flex gap=".5rem" align="center" justify="flex-end" wrap="wrap" style={{ flex: 1 }}>
					{!isAllTransactionValidInDeal && (
						<CapInvalidTransactionsWarning
							showInvalidTransactions={navigateToEntityWithInvalidTransactions}
						/>
					)}

					{children}
				</Flex>
			</Flex>
		</PageHeader>
	);
};
